/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState, useContext } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Box, makeStyles, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, RadioGroup, FormControlLabel, Radio, MenuItem, Select, FormControl, InputLabel, IconButton, InputAdornment, List, ListItem, Paper, Badge } from '@material-ui/core';
import AuthCheckComponent from '../../Layouts/Token';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import AuthApi from '../../Services/Authapi';
import Breadcrumb from '../../Layouts/Breadcrumb';
import ExportButton from '../../Layouts/ExportButton';
import swal from 'sweetalert';
import { Tabs, Tab, TablePagination } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import SearchIcon from '@material-ui/icons/Search';
import { FormLabel } from '@material-ui/core';
import ClearIcon from "@material-ui/icons/Clear";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import BusinessIcon from '@material-ui/icons/Business';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import CakeIcon from '@material-ui/icons/Cake';
import WcIcon from '@material-ui/icons/Wc';
import SchoolIcon from '@material-ui/icons/School';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import DateRangeIcon from '@material-ui/icons/DateRange';
import WorkIcon from '@material-ui/icons/Work';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import "./user.css"
import Tooltip from "@material-ui/core/Tooltip";
import FontAwesomeIconComponent from "../../Layouts/FontAwesomeIconComponent";
import { useHistory } from "react-router-dom";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import ProfileCompletionCircle from '../../Layouts/ProfileCompletionCircle';
import TooltipCell from '../../TooltipCell';
import defaultAvatar from '../../../Images/person.jpg';
import { ThemeContext } from '../../../ThemeContext';



const getContrastYIQ = (hexcolor) => {
  if (!hexcolor) return 'black';
  // If hexcolor is something like "#000000", convert to rgb
  let r, g, b;
  if (hexcolor.startsWith('#')) {
    const hex = hexcolor.replace('#', '');
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else {
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
    }
  } else if (hexcolor.startsWith('rgb')) {
    const rgb = hexcolor.match(/\d+/g);
    r = parseInt(rgb[0]);
    g = parseInt(rgb[1]);
    b = parseInt(rgb[2]);
  } else {
    return 'black';
  }
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
};

const useStyles = makeStyles((theme) => ({
  profileCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
    padding: theme.spacing(3),
    textAlign: 'center',
    position: 'sticky',
    top: theme.spacing(10),
    border: `1px solid ${theme.palette.divider}`,
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 25px 0 rgba(0,0,0,0.1)',
    },
  },
  detailsCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
    padding: theme.spacing(4),
    border: `1px solid ${theme.palette.divider}`,
  },
  profilePhoto: {
    width: '120px',
    height: '120px',
    border: `4px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows[3],
    borderRadius: '50%',
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    objectFit: 'cover',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1.5),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '1.25rem',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  sectionIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
  },
  infoItem: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f8f9fa',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Push label and value to opposite sides
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#f0f2f5',
      borderColor: theme.palette.primary.main,
      transform: 'translateY(-2px)',
    },
  },
  infoLabel: {
    fontWeight: 700,
    color: '#1B6E95',
    fontSize: '0.8rem', // Slightly smaller to save space
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    minWidth: '140px', // Reduced width to give more space to value
  },
  labelIcon: {
    fontSize: '1.2rem',
    color: '#1B6E95',
  },
  infoValue: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    fontSize: '0.9rem', // Reduced font size to prevent wrapping
    wordBreak: 'break-word',
    lineHeight: 1.5,
    textAlign: 'right',
    flex: 1,
    paddingLeft: theme.spacing(2),
  },
  editButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '6px 16px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      backgroundColor: theme.palette.action.hover,
    },
    [theme.breakpoints.up('sm')]: {
      borderColor: theme.palette.type === 'dark' ? '#90caf9' : theme.palette.primary.main,
      color: theme.palette.type === 'dark' ? '#90caf9' : theme.palette.primary.main,
    }
  },
  socialIcon: {
    fontSize: 40,
    margin: theme.spacing(1),
  },
  container: {
    padding: theme.spacing(3),
  },
  cardContent: {
    padding: theme.spacing(0),
  },
  appBar: {
    marginBottom: theme.spacing(3),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  actionButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 20px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
      transform: 'translateY(-1px)',
    },
  },
  tabRoot: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    marginRight: theme.spacing(4),
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    '&$tabSelected': {
      color: theme.palette.primary.main,
    },
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  tabSelected: {},
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(2, 3),
    '& h2': {
      fontSize: '1.25rem',
      fontWeight: 700,
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  customTextField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f8f9fa',
      '& fieldset': {
        borderColor: theme.palette.divider,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      color: '#1B6E95',
      fontWeight: 700,
      textTransform: 'uppercase',
      fontSize: '0.75rem',
      letterSpacing: '0.5px',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: '#1B6E95 !important',
    },
  },
  qualificationSelect: {
    '& .MuiSelect-select': {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: theme.spacing(4),
    },
  },
  uploadArea: {
    width: '100%',
    minHeight: '100px',
    border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : '#cbd5e1'}`,
    borderRadius: '1rem',
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f1f5f9',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : '#94a3b8',
    },
  },
  uploadAreaActive: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '#ffffff',
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 4px ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(30, 41, 59, 0.1)'}`,
  },
  fileInput: {
    display: 'none',
  },
}));

const getFieldDisplayName = (fieldName) => {
  const fieldMappings = {
    "firstName": "First Name",
    "lastName": "Last Name",
    "photo": "Profile Photo",
    "dob": "Date of Birth",
    "doj": "Date of Joining",
    "bankName": "Bank Name",
    "bankAccNo": "Bank Account Number",
    "designation": "Designation",
    "email": "Email",
    "personal_email": "Personal Email",
    "mobileNo": "Mobile Number",
    "last_organization": "Last Organization",
    "location": "Location",
    "qualification": "Qualification"
  };
  return fieldMappings[fieldName] || fieldName;
};

const UserDetails = (props) => {
  const classes = useStyles();
  const themeContext = useContext(ThemeContext);
  const darkMode = themeContext ? themeContext.darkMode : false;
  const { users = [], authToken, authUser } = props;
  const [userimg1, setuserimg] = useState([]);
  const [userDetails, setuserDetails] = useState("");
  const { userId: encodedUserId } = useParams();
  const decodedString = atob(encodedUserId);
  const userId = decodedString.split('-')[0];
  const location = useLocation();
  const [openEditPersonal, setOpenEditPersonal] = useState(false);
  const [openEditBank, setOpenEditBank] = useState(false);
  const [openEditOffice, setOpenEditOffice] = useState(false);
  const [qualifications, setQualifications] = useState([]);
  const [qualificationsLoaded, setQualificationsLoaded] = useState(false);
  const [photo, setPhoto] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [leaveMonthYear, setLeaveMonthYear] = useState(new Date());
  const history = useHistory()
  const [selectedMonthYear, setSelectedMonthYear] = useState(new Date().toISOString().slice(0, 7));
  const [salary, setSalary] = useState([]);
  const [salarySourceData, setSalarySourceData] = useState([]);
  const [slip, setslip] = React.useState([]);
  const [Pdf, setPdf] = React.useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leavePage, setLeavePage] = useState(0);
  const [salaryPage, setSalaryPage] = useState(0);
  const [leaveBalancePage, setLeaveBalancePage] = useState(0);
  const [totalDurationTime, setTotalDurationTime] = useState([]);
  const [attendanceSourceData, setAttendanceSourceData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionData, setSuggestionData] = useState([]);
  const [searchSalaryQuery, setSearchSalaryQuery] = useState("");
  const [Salarysuggestions, setSalarySuggestions] = useState([]);
  const [SalaryshowSuggestions, setSalaryShowSuggestions] = useState(false);
  const [SalarysuggestionData, setSalarySuggestionData] = useState([]);
  const [searchLeaveQuery, setSearchLeaveQuery] = useState("");
  const [Leavesuggestions, setLeaveSuggestions] = useState([]);
  const [LeaveshowSuggestions, setLeaveShowSuggestions] = useState(false);
  const [LeavesuggestionData, setLeaveSuggestionData] = useState([]);
  const [timeRange, setTimeRange] = useState("today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [modalTimeRange, setModalTimeRange] = useState("today");
  const [modalStartDate, setModalStartDate] = useState("");
  const [modalEndDate, setModalEndDate] = useState("");
  const [editPersonalInfo, setEditPersonalInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    personal_email: '',
    dob: '',
    gender: '',
    qualification: '',
    lastOrganization: '',
    mobileNo: ''
  });
  const [editBankInfo, setEditBankInfo] = useState({
    bankName: '',
    bankAccNo: ''
  });
  const [editOfficeInfo, setEditOfficeInfo] = useState({
    doj: '',
    designation: ''
  });
  const [leaveData, setLeaveData] = useState([]);
  const [leaveSourceData, setLeaveSourceData] = useState([]);
  const [statusColors, setStatusColors] = useState({});
  const [leaveBalanceData, setLeaveBalanceData] = useState([]);
  const [leaveBalanceLoading, setLeaveBalanceLoading] = useState(false);
  const [leaveBalanceMonth, setLeaveBalanceMonth] = useState('All');
  const [leaveBalanceYear, setLeaveBalanceYear] = useState('All');
  const [leaveBalanceMonthYear, setLeaveBalanceMonthYear] = useState('');
  const [dragActive, setDragActive] = useState(false);


  // Authorization guard: Only allow Super Admins or the profile owner
  useEffect(() => {
    try {
      const storedUserRaw = typeof window !== 'undefined' ? localStorage.getItem('user') : null;
      const storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : null;
      const currentUserRoles = (storedUser && storedUser.roles) || (authUser && authUser.roles) || [];
      const isSuperAdmin = Array.isArray(currentUserRoles) && currentUserRoles.some((r) => {
        if (!r) return false;
        if (typeof r === 'string') return r.toLowerCase() === 'super admin';
        if (typeof r === 'object' && r.name) return String(r.name).toLowerCase() === 'super admin';
        return false;
      });
      const isOwnProfile = storedUser && String(storedUser.id) === String(userId);
      if (!isSuperAdmin && !isOwnProfile) {
        swal({
          title: 'Access denied',
          text: 'You are not authorized to view this user profile.',
          icon: 'error',
        }).then(() => {
          history.replace('/dashboard');
        });
      }
    } catch (e) {
      // In case of parsing errors, fail closed
      history.replace('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const userimg = async () => {
    if (userId) {
      let users = await AuthApi.userimgid(userId);
      setuserimg(users);
    }
  };

  const fetchUserDetails = async () => {
    if (userId) {
      let users = await AuthApi.singleUser(userId);
      setuserDetails(users.data);
    }
  };

  useEffect(() => {
    userimg();
    fetchUserDetails();
  }, [userId]);

  useEffect(() => {
    if (userDetails) {
      setEditPersonalInfo({
        firstName: userDetails.firstName || '',
        lastName: userDetails.lastName || '',
        email: userDetails.email || '',
        personal_email: userDetails.personal_email || '', // Added personal_email
        dob: userDetails.dob || '',
        gender: userDetails.gender || '',
        qualification: userDetails.qualification || '',
        last_organization: userDetails.last_organization || '',
        mobileNo: userDetails.mobileNo || '',
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        bankName: userDetails.bankName,
        bankAccNo: userDetails.bankAccNo,
        doj: userDetails.doj,
        location: userDetails.location,
        department: userDetails.department,
        designation: userDetails.designation,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setEditBankInfo({
        bankName: userDetails.bankName || '',
        bankAccNo: userDetails.bankAccNo || '',
        firstName: userDetails.firstName || '',
        lastName: userDetails.lastName || '',
        email: userDetails.email || '',
        personal_email: userDetails.personal_email || '',
        dob: userDetails.dob || '',
        gender: userDetails.gender || '',
        qualification: userDetails.qualification || '',
        last_organization: userDetails.last_organization || '',
        mobileNo: userDetails.mobileNo || '',
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        doj: userDetails.doj,
        location: userDetails.location,
        department: userDetails.department,
        designation: userDetails.designation,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setEditOfficeInfo({
        doj: userDetails.doj || '',
        designation: userDetails.designation || '',
        bankName: userDetails.bankName,
        bankAccNo: userDetails.bankAccNo,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
        personal_email: userDetails.personal_email || '',
        dob: userDetails.dob,
        gender: userDetails.gender,
        qualification: userDetails.qualification,
        last_organization: userDetails.last_organization,
        mobileNo: userDetails.mobileNo,
        photo: photo,
        roleName: userDetails.roleName,
        uploadedImgName: userDetails.uploadedImgName,
        salary: userDetails.salary,
        location: userDetails.location,
        department: userDetails.department,
        password: userDetails.password,
        user_id: userDetails.user_id,
        allowed_ip: userDetails.allowed_ip,
      });

      setPhoto(userDetails.photo || '');
    }
  }, [userDetails]);

  const handleEditOpen = (section) => {
    switch (section) {
      case 'personal':
        setOpenEditPersonal(true);
        break;
      case 'bank':
        setOpenEditBank(true);
        break;
      case 'office':
        setOpenEditOffice(true);
        break;
      default:
        break;
    }
  };

  const handleEditClose = (section) => {
    switch (section) {
      case 'personal':
        setOpenEditPersonal(false);
        break;
      case 'bank':
        setOpenEditBank(false);
        break;
      case 'office':
        setOpenEditOffice(false);
        break;
      default:
        break;
    }
  };

  const handleUpdateUser = async (section) => {
    if (section === 'personal') {
      if (editPersonalInfo.mobileNo && editPersonalInfo.mobileNo.length !== 10) {
        swal({
          title: "Invalid Input",
          text: "Phone number must be exactly 10 digits.",
          icon: "error",
          button: "Ok",
        });
        return;
      }
    }

    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: {
        element: "img",
        attributes: {
          src: "https://www.boasnotas.com/img/loading2.gif",
          style: "width: 50px;"
        }
      }
    });
    try {
      let updateData = {};
      switch (section) {
        case 'personal':
          updateData = {
            ...editPersonalInfo,
            dob: formatDate(editPersonalInfo.dob),
            photo
          };
          break;
        case 'bank':
          updateData = {
            ...editBankInfo,
            dob: formatDate(editBankInfo.dob),
            photo
          };
          break;
        case 'office':
          updateData = {
            ...editOfficeInfo,
            dob: formatDate(editOfficeInfo.dob),
            photo
          };
          break;
        default:
          break;
      }
      let status = await AuthApi.updateUser(updateData, userId);
      swal.close();
      if (status && status.status === true) {
        swal("Success", "Personal info updated successfully", "success");
        fetchUserDetails();
        userimg();
        handleEditClose(section);
      } else {
        swal("Error", status && status.message ? status.message : "Failed to update user data", "error");
      }
    } catch (error) {
      console.error('Error updating user data:', error);
    }
  };

  function formatDate(dob) {
    if (!dob) return '';
    const parts = dob.split("-");
    return `${parts[0]}-${parts[1]}-${parts[2]}`;
  }
  const month = leaveMonthYear.getMonth() + 1;
  const year = leaveMonthYear.getFullYear();
  useEffect(() => {
    const month = leaveMonthYear.getMonth() + 1;
    const year = leaveMonthYear.getFullYear();
    userreportAttendance(userId, timeRange);
    fetchLeaveTickets(userId, month, year);
    getQualificationData()
  }, [userId, month, year, timeRange, leaveMonthYear]);

  useEffect(() => {
    AuthApi.getStatusColors().then((response) => {
      if (response && response.status && response.data) {
        const fetchedColors = response.data;
        const defaultColors = {
          'Present': '#1dbb11',
          'Absent': '#ff5c5c',
          'Half day': '#0acdb6',
          'Left Early': '#065112',
          'Late': '#9d744d',
          'Week Off': '#0f38db',
          'Holiday': '#ca04cd',
          'Short Hours': '#ffffff'
        };

        Object.keys(defaultColors).forEach(key => {
          if (!fetchedColors[key] || (typeof fetchedColors[key] === 'string' && (fetchedColors[key].toLowerCase() === '#ffffff' || fetchedColors[key].toLowerCase() === '#fff'))) {
            fetchedColors[key] = defaultColors[key];
          }
        });

        if (fetchedColors['Comes Late'] && !fetchedColors['Late']) {
          fetchedColors['Late'] = fetchedColors['Comes Late'];
        }
        setStatusColors(fetchedColors);
      } else {
        setStatusColors({});
      }
    });
  }, []);

  const getQualificationData = async () => {
    try {
      const response = await AuthApi.getQulification();
      if (response && response.data) {
        setQualifications(response.data);
      }
    } catch (error) {
      console.error('Error fetching qualification data:', error);
    } finally {
      setQualificationsLoaded(true);
    }
  };

  const handlePersonalInfoChange = (e) => {
    const { name, value } = e.target;
    if (name === 'dob') {
      const [year, month, day] = value.split('-');
      const formattedDate = `${day}-${month}-${year}`;
      setEditPersonalInfo((prev) => ({ ...prev, [name]: formattedDate }));
    } else if (name === 'mobileNo') {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setEditPersonalInfo((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setEditPersonalInfo((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleBankInfoChange = (e) => {
    const { name, value } = e.target;
    setEditBankInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleOfficeInfoChange = (e) => {
    const { name, value } = e.target;
    setEditOfficeInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  function formatDate(dateString) {
    if (!dateString) return '';
    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
  }

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
    userreportAttendance(userId, event.target.value);
  };

  const openFilterModal = () => {
    setShowFilterModal(true);
    setModalTimeRange(timeRange);
    setModalStartDate(startDate);
    setModalEndDate(endDate);
  };

  const applyFilters = () => {
    setTimeRange(modalTimeRange);
    setStartDate(modalStartDate);
    setEndDate(modalEndDate);
    setShowFilterModal(false);

    if (modalStartDate && modalEndDate) {
      handleDateRangeChange(modalStartDate, modalEndDate);
    } else {
      userreportAttendance(userId, modalTimeRange);
    }
  };

  const clearFilters = () => {
    setTimeRange("today");
    setStartDate("");
    setEndDate("");
    setModalTimeRange("today");
    setModalStartDate("");
    setModalEndDate("");
    setShowFilterModal(false);
    userreportAttendance(userId, "today");
  };

  const handleDateRangeChange = async (startDate, endDate) => {
    if (startDate && endDate) {
      const [startYear, startMonth, startDay] = startDate.split("-");
      const [endYear, endMonth, endDay] = endDate.split("-");
      const response = await AuthApi.getUserReportByDateRange(userId, startDay, startMonth, startYear, endDay, endMonth, endYear);
      if (response && response.data) {
        const formattedData = response.data.map((item, index) => ({
          id: index,
          name: item.user_name,
          firstName: item.firstname,
          status: item.status,
          date: item.date,
          lastouttime: item.last_out_time,
          firstintime: item.first_in_time,
          breaks: item.breaks,
          breakduration: item.break_duration,
          totalduration: item.total_duration,
        }));
        setAttendanceSourceData(formattedData);
        setOriginalData(formattedData);
        setTotalDurationTime(filterRowsByQuery(formattedData, searchQuery));
      } else {
        setAttendanceSourceData([]);
        setTotalDurationTime([]);
      }
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    handleDateRangeChange(startDate, newEndDate);
  };

  const userreportAttendance = async (userId, timeRange) => {
    try {
      const response = await AuthApi.userreportAttendance(userId, timeRange);
      const data = response.data;
      const firstNames = data.map(item => item.firstname);
      const uniqueFirstNames = [...new Set(firstNames)];
      setSuggestionData(uniqueFirstNames);
      if (response && response.data) {
        const formattedData = response.data.map((item, index) => ({
          id: index,
          name: item.user_name,
          firstName: item.firstname,
          status: item.status,
          date: item.date,
          lastouttime: item.last_out_time,
          firstintime: item.first_in_time,
          breaks: item.breaks,
          breakduration: item.break_duration,
          totalduration: item.total_duration,
        }));
        setAttendanceSourceData(formattedData);
        setOriginalData(formattedData);
        setTotalDurationTime(filterRowsByQuery(formattedData, searchQuery));
      } else {
        setAttendanceSourceData([]);
        setTotalDurationTime([]);
      }
    } catch (error) {
      console.error('Error fetching attendance data:', error);
      setAttendanceSourceData([]);
      setTotalDurationTime([]);
    }
  };

  const filterRowsByQuery = (rows, query) => {
    const normalizedQuery = (query || "").toLowerCase().trim();

    if (!normalizedQuery) {
      return rows;
    }

    return rows.filter((item) =>
      Object.values(item).some((value) => {
        if (value != null) {
          return value.toString().toLowerCase().includes(normalizedQuery);
        }

        return false;
      })
    );
  };

  const applyAttendanceSearch = (query) => {
    setTotalDurationTime(filterRowsByQuery(attendanceSourceData, query));
  };

  const applySalarySearch = (query) => {
    setSalary(filterRowsByQuery(salarySourceData, query));
  };

  const applyLeaveSearch = (query) => {
    setLeaveData(filterRowsByQuery(leaveSourceData, query));
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredSuggestions = suggestionData.filter(suggestion =>
        typeof suggestion === 'string' && suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }

    applyAttendanceSearch(query);
  };

  const handleSearch = () => {
    setShowSuggestions(false);
    applyAttendanceSearch(searchQuery);
  };

  const handleSuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchQuery(nextQuery);
    setSuggestions([]);
    setShowSuggestions(false);
    applyAttendanceSearch(nextQuery);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setSuggestions([]);
    setShowSuggestions(false);
    setTotalDurationTime(attendanceSourceData);
  };

  const handleSalarySearchChange = (e) => {
    const query = e.target.value;
    setSearchSalaryQuery(query);

    if (query) {
      const filteredSuggestions = SalarysuggestionData.filter(suggestion =>
        suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setSalarySuggestions(filteredSuggestions);
      setSalaryShowSuggestions(true);
    } else {
      setSalarySuggestions([]);
      setSalaryShowSuggestions(false);
    }

    applySalarySearch(query);
  };

  const handleSalarySearch = () => {
    setSalaryShowSuggestions(false);
    applySalarySearch(searchSalaryQuery);
  };


  const handleSalarySuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchSalaryQuery(nextQuery);
    setSalaryShowSuggestions(false);
    setSalarySuggestions([]);
    applySalarySearch(nextQuery);
  };

  const handleSalaryClearSearch = () => {
    setSearchSalaryQuery('');
    setSalarySuggestions([]);
    setSalaryShowSuggestions(false);
    setSalary(salarySourceData);
  };


  const handleLeaveSearchChange = (e) => {
    const query = e.target.value;
    setSearchLeaveQuery(query);

    if (query) {
      const filteredSuggestions = LeavesuggestionData && LeavesuggestionData.filter(suggestion =>
        suggestion.toLowerCase().includes(query.toLowerCase())
      );
      setLeaveSuggestions(filteredSuggestions || []);
      setLeaveShowSuggestions(true);
    } else {
      setLeaveSuggestions([]);
      setLeaveShowSuggestions(false);
    }

    applyLeaveSearch(query);
  };


  const handleLeaveSearch = async () => {
    setLeaveShowSuggestions(false);
    applyLeaveSearch(searchLeaveQuery);
  };

  const handleLeaveSuggestionClick = (suggestion) => {
    const nextQuery = suggestion || "";
    setSearchLeaveQuery(nextQuery);
    setLeaveShowSuggestions(false);
    setLeaveSuggestions([]);
    applyLeaveSearch(nextQuery);
  };

  const handleLeaveClearSearch = () => {
    setSearchLeaveQuery('');
    setLeaveSuggestions([]);
    setLeaveShowSuggestions(false);
    setLeaveData(leaveSourceData);
  };

  const columns = [
    { field: 'name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'firstName', headerName: 'Name', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div> },
    { field: 'date', headerName: 'Date', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const displayValue = params.value === 'Comes Late' ? 'Late' : params.value;
        const color = statusColors && statusColors[displayValue] ? statusColors[displayValue] : '#000000';
        return (
          <div
            style={{
              display: 'inline-block',
              backgroundColor: color,
              color: getContrastYIQ(color),
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '12px',
              fontFamily: 'Arial, sans-serif',
              minWidth: '90px',
              width: 'auto',
              textAlign: 'center',
            }}
          >
            {displayValue}
          </div>
        );
      }
    },
    { field: 'firstintime', headerName: 'First In Time', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'lastouttime', headerName: 'Last Out Time', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'totalduration',
      headerName: 'Total Duration',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'breakduration',
      headerName: 'Break Duration',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {params.value}
          </div>
        );
      }
    },
    { field: 'breaks', headerName: 'Breaks', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
  ];

  const leaveColumns = [
    { field: 'emp_id', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'firstName', headerName: 'Name', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div> },
    { field: 'leaveType', headerName: 'Leave Type', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'ticket_mesasge', headerName: 'Ticket Mesasge', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'date_range',
      headerName: 'Date Range',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(/\s+to\s+/i);
        if (parts.length === 2) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: '1.2', padding: '10px 0' }}>
              <span style={{ whiteSpace: 'nowrap' }}>{parts[0]}</span>
              <span style={{ fontSize: '0.85em', opacity: 0.8, margin: '2px 0' }}>To</span>
              <span style={{ whiteSpace: 'nowrap' }}>{parts[1]}</span>
            </div>
          );
        }
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{val}</div>;
      }
    },
    { field: 'no_of_days', headerName: 'No Of Days', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const displayValue = params.value === 'Comes Late' ? 'Late' : params.value;
        const color = statusColors && statusColors[displayValue] ? statusColors[displayValue] : '#e5e562ff';
        return (
          <div
            style={{
              display: 'inline-block',
              backgroundColor: color,
              color: getContrastYIQ(color),
              padding: '4px 8px',
              borderRadius: '4px',
              fontWeight: 'bold',
              fontSize: '12px',
              fontFamily: 'Arial, sans-serif',
              minWidth: '90px',
              width: 'auto',
              textAlign: 'center',
            }}
          >
            {displayValue}
          </div>
        );
      }
    },
    { field: 'cancel_reason', headerName: 'Reason for Declined', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'c_reason', headerName: 'Reason for Cancel', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'created_at',
      headerName: 'Created At',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(' ');
        return (
          <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
            <span>{parts[0]}</span>
            <span style={{ fontSize: '0.85em', color: 'gray' }}>{parts.slice(1).join(' ')}</span>
          </div>
        );
      }
    },
    {
      field: 'updated_at',
      headerName: 'Updated',
      flex: 1,
      headerClassName: 'header-red',
      renderCell: (params) => {
        const val = params.value || '';
        const parts = val.split(' ');
        return (
          <div style={{ lineHeight: '1.2', display: 'flex', flexDirection: 'column' }}>
            <span>{parts[0]}</span>
            <span style={{ fontSize: '0.85em', color: 'gray' }}>{parts.slice(1).join(' ')}</span>
          </div>
        );
      }
    },
  ];

  const fetchLeaveTickets = async (userId, month, year) => {
    try {
      const response = await AuthApi.leavetickets(userId, month, year);
      const data = response.data;
      const firstNames = data.map(item => item.firstName);
      const uniqueFirstNames = [...new Set(firstNames)];
      setLeaveSuggestionData(uniqueFirstNames);
      if (response && response.data) {
        setLeaveSourceData(response.data);
        setLeaveData(filterRowsByQuery(response.data, searchLeaveQuery));
        setOriginalData(response.data);
      } else {
        setLeaveSourceData([]);
        setLeaveData([]);
      }
      return response.data.data;
    } catch (error) {
      console.error("Error fetching leave tickets:", error);
      setLeaveSourceData([]);
      setLeaveData([]);
      setOriginalData([]);
    }
  };

  const handleMonthChange = (event) => {
    const date = new Date(event.target.value);
    setLeaveMonthYear(date);
  };

  const openModal = async (user_id) => {
    try {
      const slip = await AuthApi.viewSalarySlip(user_id);
      if (slip) {
        setslip(slip)
      } else {
      }
      setPdf(true)
    } catch (error) {
    }
  };

  const downloadSlip = async (id) => {
    try {
      swal({
        title: "Salaries Downloading...",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        width: "10%",
        content: {
          element: "img",
          attributes: {
            src: "https://www.boasnotas.com/img/loading2.gif",
            style: "width: 50px;"
          }
        }
      });
      const slip = await AuthApi.getAllSalaryPdf(id);
      if (slip && slip.status === true) {
      }
      swal.close();
    } catch (error) {
      console.error("Error downloading salary slip:", error);
      swal({
        title: "Error",
        text: "Failed to download salary slip. Please try again later.",
        icon: "error",
      });
    }
  }

  // const removeUser = async (id) => {
  //   swal({
  //     title: "Are you sure?",
  //     icon: "warning",
  //     buttons: ["Cancel", "Yes"],
  //   }).then(async (confirm) => {
  //     if (confirm) {
  //       let currentUser = await AuthApi.Salarydelete(id);
  //       if (currentUser && currentUser.status === true) {
  //         history.push("/dashboard");
  //       } else {
  //       }
  //     }
  //   });
  // }

  const salaryColumns = [
    { field: 'name', headerName: 'Employee ID', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'firstName', headerName: 'Name', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left' }}>{params.value}</div> },
    { field: 'BasicSalary', headerName: 'Basic Salary', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'DA', headerName: 'DA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'HRA', headerName: 'HRA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'CA', headerName: 'CA', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'Tax', headerName: 'Tax', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'netSalary', headerName: 'Net Salary', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    { field: 'MonthYear', headerName: 'Month Year', flex: 1, headerClassName: 'header-red', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5' }}>{params.value}</div> },
    {
      field: 'actions', headerName: 'Actions', flex: 1, headerClassName: 'header-red', renderCell: (params) => (
        <>
          <Tooltip title="Show">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => openModal(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-eye"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={(id) => downloadSlip(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-download"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Delete">
            <IconButton
              variant="contained"
              color="primary"
              style={{ padding: "4px" }}
              onClick={() => removeUser(params.id)}
            >
              <FontAwesomeIconComponent
                classes="fa fa-trash"
                colorName="primary"
                fontSize={"small"}
              />
            </IconButton>
          </Tooltip> */}
        </>
      )
    },
  ];

  const imgUpload = async (input) => {
    let file;
    if (input.target && input.target.files) {
      file = input.target.files[0];
    } else {
      file = input;
    }

    if (!file) return;

    const postData = new FormData();
    postData.append("file", file);
    try {
      let updateImg = await AuthApi.updateImg(postData);
      if (updateImg && updateImg.status === true) {
        setPhoto(updateImg.data.image_url);
        setEditPersonalInfo((prev) => ({
          ...prev,
          photo: updateImg.data.image_url,
          uploadedImgName: updateImg.data.image_name,
        }));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      imgUpload(e.dataTransfer.files[0]);
    }
  };

  const handleMonthYearChange = (event) => {
    setSelectedMonthYear(event.target.value);
  };


  const fetchSalaryData = async () => {
    const [year, month] = selectedMonthYear.split("-");
    try {
      const response = await AuthApi.alldatasalaryid(parseInt(month), year, userId);
      if (response && response.data) {
        const data = response.data;
        setSalarySourceData(data);
        setSalary(filterRowsByQuery(data, searchSalaryQuery));
        setOriginalData(data)
        const firstNames = data.map(item => item.firstName);
        const uniqueFirstNames = [...new Set(firstNames)];
        setSalarySuggestionData(uniqueFirstNames);
      } else {
        setSalarySourceData([]);
        setSalary([]);
      }
    } catch (error) {
      console.error("Error fetching salary data:", error);
      setSalarySourceData([]);
      setSalary([]);
      setOriginalData([]);
    }
  };
  useEffect(() => {
    const [year, month] = selectedMonthYear.split("-");
    fetchSalaryData(parseInt(month), year, userId);
  }, [selectedMonthYear, userId]);

  useEffect(() => {
    if (location.state && location.state.tab === "salaryInfo") {
      setTabIndex(3);
      if (location.state.salarySlipId) {
        openModal(location.state.salarySlipId);
      }
    }
  }, [location.state]);

  // Fetch leave balance data
  useEffect(() => {
    const fetchLeaveBalance = async () => {
      setLeaveBalanceLoading(true);
      try {
        const response = await AuthApi.getLeaveBalanceByUserId(userId);
        if (response && response.status && response.data) {
          setLeaveBalanceData(response.data);
        } else {
          setLeaveBalanceData([]);
        }
      } catch (error) {
        setLeaveBalanceData([]);
      }
      setLeaveBalanceLoading(false);
    };
    if (userId) fetchLeaveBalance();
  }, [userId]);

  const monthNames = [
    '', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const leaveBalanceColumns = [
    {
      field: 'emp_id',
      headerName: 'Employee ID',
      flex: 1,
      headerClassName: 'header-red',
      align: 'left',
      headerAlign: 'left',
      valueGetter: (params) => params.row.user && params.row.user.name ? params.row.user.name : '-',
      renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div>,
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      headerClassName: 'header-red',
      align: 'left',
      headerAlign: 'left',
      valueGetter: (params) => params.row.user && params.row.user.firstName ? params.row.user.firstName : '-',
      renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div>,
    },
    {
      field: 'month',
      headerName: 'Month',
      flex: 1,
      headerClassName: 'header-red',
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => {
        const monthNum = Number(params.value);
        const display = monthNum >= 1 && monthNum <= 12 ? monthNames[monthNum] : params.value;
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{display}</div>;
      }
    },
    { field: 'year', headerName: 'Year', flex: 1, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div> },
    { field: 'paid_leave_allowed', headerName: 'Paid Leave Allowed', flex: 1, minWidth: 170, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div> },
    { field: 'paid_leave_used', headerName: 'Paid Leave Used', flex: 1, minWidth: 150, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div> },
    { field: 'carry_forward', headerName: 'Carry Forward', flex: 1, minWidth: 150, headerClassName: 'header-red', align: 'left', headerAlign: 'left', renderCell: (params) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{params.value}</div> },
    {
      field: 'carry_forward_details',
      headerName: 'Carry Forward Details',
      flex: 2,
      minWidth: 200,
      headerClassName: 'header-red',
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => {
        let details = params.value;
        let display = '-';
        try {
          const parsed = JSON.parse(details);
          if (Array.isArray(parsed) && parsed.length > 0) {
            display = parsed.map((item, idx) => {
              const monthName = monthNames[item.month] || item.month;
              return `M:${monthName}, Y:${item.year}, C:${item.count}`;
            }).join(' | ');
          }
        } catch { }
        return <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left', padding: '15px 0' }}>{display}</div>;
      }
    },

  ];

  const handleLeaveBalanceMonthYearChange = (event) => {
    setLeaveBalanceMonthYear(event.target.value);
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (timeRange) count++; // Treat time range as an active filter even if it's "today"
    if (startDate || endDate) count++; // Only 1 for date range selection
    if (searchQuery) count++;
    return count;
  };
  const activeFilterCount = getActiveFilterCount();


  // Compute available years from leaveBalanceData
  const availableYears = Array.from(new Set(leaveBalanceData.map(item => item.year))).sort();

  // Filtered data for table
  const filteredLeaveBalanceData = leaveBalanceData.filter(item => {
    if (!leaveBalanceMonthYear) return true;
    const [year, month] = leaveBalanceMonthYear.split('-');
    return String(item.year) === year && String(item.month).padStart(2, '0') === month;
  });


  const getBase64ImageFromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const downloadAttendanceXLSX = async () => {
    const formatYMD = (date) => {
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return String(date);
      return d.toISOString().slice(0, 10);
    };

    let actualStart = startDate;
    let actualEnd = endDate;
    const today = new Date();

    if (timeRange === 'today') {
      actualStart = formatYMD(today);
      actualEnd = formatYMD(today);
    } else if (timeRange === 'last7days') {
      const start = new Date(today);
      start.setDate(today.getDate() - 6);
      actualStart = formatYMD(start);
      actualEnd = formatYMD(today);
    } else if (timeRange === 'last30days') {
      const start = new Date(today);
      start.setDate(today.getDate() - 29);
      actualStart = formatYMD(start);
      actualEnd = formatYMD(today);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Attendance');
    const fillColor = 'FFFFFF00';
    for (let row = 1; row <= 2; row++) {
      for (let col = 1; col <= 8; col++) {
        const cell = worksheet.getCell(row, col);
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fillColor }
        };
      }
    }
    const base64Image = await getBase64ImageFromUrl('/logo.png');
    const imageId = workbook.addImage({
      base64: base64Image.split(',')[1],
      extension: 'png',
    });
    const columnWidth = worksheet.getColumn(1).width || 10;
    const imageWidth = 50;
    const startCol = (columnWidth - imageWidth / 7.5) / 6;
    worksheet.addImage(imageId, {
      tl: { col: startCol, row: 0 },
      ext: { width: imageWidth, height: 40 }
    });

    worksheet.getCell('B1').value = `Cherrypik Software Attendance Report`;
    worksheet.getCell('B2').value = `Date Range: ${actualStart || ''} to ${actualEnd || ''}`;
    worksheet.getCell('B3').font = { bold: true, size: 14 };

    const headerRow = worksheet.addRow(columns.filter(col => col.field !== 'firstName').map(col => col.headerName));
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF00FF00' },
      };
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
    if (totalDurationTime.length === 0) {
      worksheet.getCell('A3').value = 'No Data Available';
      worksheet.mergeCells('A3:I3');
      worksheet.getCell('A3').alignment = { horizontal: 'center' };
    } else {
      totalDurationTime.forEach((row, index) => {
        const dataRow = worksheet.addRow(columns.filter(col => col.field !== 'firstName').map(col => row[col.field]));

        // Apply status color to the status column (4th column, index 3)
        const statusCell = dataRow.getCell(3); // Status column
        const statusValue = row.status === 'Comes Late' ? 'Late' : row.status;
        const statusColor = statusColors && statusColors[statusValue] ? statusColors[statusValue] : '#000000';

        // Convert hex color to Excel color format
        const hexToRgb = (hex) => {
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        };

        const rgbColor = hexToRgb(statusColor);
        if (rgbColor) {
          statusCell.font = {
            color: { argb: `FF${rgbColor.r.toString(16).padStart(2, '0')}${rgbColor.g.toString(16).padStart(2, '0')}${rgbColor.b.toString(16).padStart(2, '0')}` },
            bold: true
          };
        }
      });
    }
    worksheet.columns.forEach(column => {
      column.width = 20;
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const firstName = (userDetails && userDetails.firstName) ? userDetails.firstName : 'User';
    const lastName = (userDetails && userDetails.lastName) ? userDetails.lastName : '';

    let rangeLabel = '';
    if (actualStart && actualEnd) {
      rangeLabel = `${actualStart}_to_${actualEnd}`;
    } else {
      rangeLabel = 'custom_range';
    }
    const fileName = `${firstName} ${lastName} Attendance ${rangeLabel}.xlsx`;
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
  };


  const profileFields = [
    "firstName", "lastName", "photo", "dob", "doj", "bankName", "bankAccNo",
    "designation", "email", "personal_email", "mobileNo", "last_organization",
    "location", "qualification"
  ];
  const profileCompletionPercentage = (() => {
    const user = userDetails || {};
    const filled = profileFields.filter(field => user[field] && user[field].toString().trim() !== "").length;
    return Math.round((filled / profileFields.length) * 100);
  })();

  return (
    <div>
      <AuthCheckComponent authToken={authToken} />
      <Header
        {...props}
        authUser={authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: '3%' }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Users"
                  primaryPageLink="/users"
                  isSecondaryPage={true}
                  secondaryPageName="User Profile" />
              </CardContent>
            </Card>

            <div style={{ width: "100%" }}>
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                aria-label="settings tabs"
                indicatorColor="primary"
                textColor="primary"
                style={{ marginBottom: '20px', borderBottom: '1px solid #e0e0e0' }}
              >
                <Tab label="User Profile" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="User Attendance" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Leave" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Salary Slip" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab label="Leave Balance" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
              </Tabs>

              <TabPanel value={tabIndex} index={0}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <Card className={classes.profileCard}>
                      <CardContent>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
                          <Box style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                            <ProfileCompletionCircle
                              percentage={profileCompletionPercentage}
                              user={userDetails}
                              fields={profileFields}
                              size={130}
                              getFieldDisplayName={getFieldDisplayName}
                            />
                            <img
                              src={(userimg1 && userimg1.data && typeof userimg1.data === 'string' && userimg1.data.trim() !== "" && userimg1.data !== "null" && userimg1.data !== "undefined") ? userimg1.data : defaultAvatar}
                              alt="User"
                              onError={(e) => { e.target.onerror = null; e.target.src = defaultAvatar; }}
                              style={{
                                width: "110px",
                                height: "110px",
                                borderRadius: "50%",
                                position: 'absolute',
                                zIndex: 1,
                                objectFit: 'cover',
                                border: '4px solid white',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                              }}
                            />
                          </Box>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: 'bold',
                              color: profileCompletionPercentage >= 90 ? '#52C41A' :
                                profileCompletionPercentage >= 70 ? '#FFA500' :
                                  profileCompletionPercentage >= 40 ? '#aaa20b' : '#FF4D4F'
                            }}
                          >
                            Profile Completion: {profileCompletionPercentage}%
                          </Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center' }}>
                          <Typography className={classes.infoLabel}>Department</Typography>
                          <Typography className={classes.infoValue}>{userDetails.department || '-'}</Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center' }}>
                          <Typography className={classes.infoLabel}>Role</Typography>
                          <Typography className={classes.infoValue}>
                            {userDetails.roles && userDetails.roles.length > 0 ? userDetails.roles[0].name : '-'}
                          </Typography>
                        </div>

                        <div className={classes.infoItem} style={{ textAlign: 'center', marginBottom: 0 }}>
                          <Typography className={classes.infoLabel}>Registered Email</Typography>
                          <Typography className={classes.infoValue}>{userDetails.email}</Typography>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item xs={12} sm={8} style={{ marginBottom: "50px" }}>
                    <Card className={classes.detailsCard}>
                      <CardContent className={classes.cardContent}>

                        {/* Personal Info Section */}
                        <Box mb={4}>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <PersonIcon className={classes.sectionIcon} />
                              Personal Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('personal')}
                            >
                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <PersonIcon className={classes.labelIcon} /> Name
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.firstName} {userDetails.lastName}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <PhoneIcon className={classes.labelIcon} /> Phone Number
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.mobileNo || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <EmailIcon className={classes.labelIcon} /> Personal Email
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.personal_email || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <EmailIcon className={classes.labelIcon} /> Official Email ID
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.email}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <CakeIcon className={classes.labelIcon} /> Date of Birth
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.dob || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <WcIcon className={classes.labelIcon} /> Gender
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.gender || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <SchoolIcon className={classes.labelIcon} /> Qualification
                                </Typography>
                                <Typography className={classes.infoValue}>
                                  {userDetails.qualification && userDetails.qualification !== 'None'
                                    ? userDetails.qualification
                                    : 'None'}
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <BusinessIcon className={classes.labelIcon} /> Last Organization
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.last_organization || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <LocationOnIcon className={classes.labelIcon} /> Address
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.location || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Bank Info Section */}
                        <Box mb={4}>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <AccountBalanceIcon className={classes.sectionIcon} />
                              Bank Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('bank')}
                            >
                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <AccountBalanceIcon className={classes.labelIcon} /> Bank Name
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.bankName || '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <ConfirmationNumberIcon className={classes.labelIcon} /> Bank Acc No
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.bankAccNo || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Office Info Section */}
                        <Box>
                          <div className={classes.sectionHeader}>
                            <Typography variant="h6" className={classes.sectionTitle}>
                              <BusinessIcon className={classes.sectionIcon} />
                              Office Info
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              startIcon={<EditIcon />}
                              className={classes.editButton}
                              onClick={() => handleEditOpen('office')}
                            >

                              Edit
                            </Button>
                          </div>
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <DateRangeIcon className={classes.labelIcon} /> Date Of Joining
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.doj ? formatDate(userDetails.doj) : '-'}</Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <div className={classes.infoItem}>
                                <Typography className={classes.infoLabel}>
                                  <WorkIcon className={classes.labelIcon} /> Designation
                                </Typography>
                                <Typography className={classes.infoValue}>{userDetails.designation || '-'}</Typography>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* Edit Dialogs */}
                <Dialog
                  open={openEditPersonal}
                  onClose={() => handleEditClose('personal')}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Personal Info</Typography>
                  </DialogTitle>
                  <DialogContent className={classes.dialogContent}>
                    <DialogContentText>
                      Update your personal information here.
                    </DialogContentText>

                    <Grid container spacing={2}>
                      {/* Profile Picture Drag & Drop */}
                      <Grid item xs={12}>
                        <div
                          className={`${classes.uploadArea} ${dragActive ? classes.uploadAreaActive : ''}`}
                          onDragEnter={handleDrag}
                          onDragLeave={handleDrag}
                          onDragOver={handleDrag}
                          onDrop={handleDrop}
                          onClick={() => document.getElementById('raised-button-file').click()}
                        >
                          <input
                            accept="image/*"
                            className={classes.fileInput}
                            id="raised-button-file"
                            type="file"
                            onChange={imgUpload}
                          />
                          <img
                            src={editPersonalInfo.photo || defaultAvatar}
                            alt="User profile image"
                            style={{
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              marginBottom: '8px',
                              objectFit: 'cover',
                              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                            }}
                          />
                          <Typography variant="subtitle2" style={{ color: '#1B6E95', fontWeight: 'bold', marginBottom: '2px' }}>
                            Drag & Drop your file here
                          </Typography>
                          <Typography variant="caption" color="textSecondary" style={{ marginBottom: '4px' }}>
                            or
                          </Typography>
                          <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            size="small"
                            startIcon={<CloudUploadIcon />}
                            style={{ textTransform: 'none', fontWeight: 'bold', padding: '2px 10px', fontSize: '0.8rem' }}
                          >
                            Upload a file
                          </Button>
                        </div>
                      </Grid>
                      {/* First Name / Last Name */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="First Name"
                          placeholder="Enter First Name"
                          name="firstName"
                          value={editPersonalInfo.firstName}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Last Name"
                          placeholder="Enter Last Name"
                          name="lastName"
                          value={editPersonalInfo.lastName}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      {/* Emails */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Email Address"
                          placeholder="Enter Email Address"
                          name="email"
                          value={editPersonalInfo.email}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Personal Email"
                          placeholder="Enter Personal Email"
                          name="personal_email"
                          value={editPersonalInfo.personal_email}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>



                      {/* Birthday and Gender in same row */}
                      {/* Birthday and Gender */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Birthday"
                          type="date"
                          name="dob"
                          value={formatDate(editPersonalInfo.dob)}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CakeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl component="fieldset" fullWidth>
                          <FormLabel component="legend">Gender</FormLabel>
                          <RadioGroup
                            row
                            aria-label="gender"
                            name="gender"
                            onChange={handlePersonalInfoChange}
                            value={editPersonalInfo.gender}
                          >
                            <FormControlLabel value="Female" control={<Radio />} label="Female" />
                            <FormControlLabel value="Male" control={<Radio />} label="Male" />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      {/* Qualification and Last Organization */}
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth className={`${classes.customTextField} ${classes.qualificationSelect}`}>
                          <InputLabel id="demo-simple-select-outlined-label">Qualification</InputLabel>
                          <Select
                            id="outlined-basic"
                            name="qualification"
                            label="Qualification"
                            variant="outlined"
                            value={qualifications.find(q => q.qualification.toLowerCase() === (editPersonalInfo.qualification || '').toLowerCase())?.qualification || 'None'}
                            onChange={handlePersonalInfoChange}
                            startAdornment={
                              <InputAdornment position="start">
                                <SchoolIcon />
                              </InputAdornment>
                            }
                          >
                            <MenuItem value="None">
                              <em>None</em>
                            </MenuItem>
                            {qualifications.map((qualification) => (
                              <MenuItem key={qualification.id} value={qualification.qualification}>
                                {qualification.qualification}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Last Organization"
                          name="last_organization"
                          value={editPersonalInfo.last_organization}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <BusinessIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      {/* Phone Number and Location */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Phone Number"
                          name="mobileNo"
                          value={editPersonalInfo.mobileNo}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          error={editPersonalInfo.mobileNo.length > 0 && editPersonalInfo.mobileNo.length < 10}
                          helperText={editPersonalInfo.mobileNo.length > 0 && editPersonalInfo.mobileNo.length < 10 ? "Phone number must be 10 digits" : ""}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Location"
                          name="location"
                          value={editPersonalInfo.location}
                          onChange={handlePersonalInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LocationOnIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button onClick={() => handleUpdateUser('personal')} color="primary" variant="contained" className={classes.actionButton}>
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('personal')} color="default" variant="outlined" className={classes.actionButton}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>


                <Dialog
                  open={openEditBank}
                  onClose={() => handleEditClose('bank')}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Bank Info</Typography>
                  </DialogTitle>
                  <DialogContent className={classes.dialogContent}>
                    <DialogContentText>
                      Update your bank information here.
                    </DialogContentText>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Bank Name"
                          name="bankName"
                          placeholder="Enter Bank Name"
                          value={editBankInfo.bankName}
                          onChange={handleBankInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AccountBalanceIcon />
                              </InputAdornment>
                            ),
                          }}
                        />

                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Bank Account Number"
                          name="bankAccNo"
                          placeholder="Enter Bank AccNo"
                          value={editBankInfo.bankAccNo}
                          onChange={handleBankInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <ConfirmationNumberIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button onClick={() => handleUpdateUser('bank')} color="primary" variant="contained" className={classes.actionButton}>
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('bank')} color="default" variant="outlined" className={classes.actionButton}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  open={openEditOffice}
                  onClose={() => handleEditClose('office')}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: { borderRadius: 16 }
                  }}
                >
                  <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6">Edit Office Info</Typography>
                  </DialogTitle>
                  <DialogContent className={classes.dialogContent}>
                    <DialogContentText>
                      Update your office information here.
                    </DialogContentText>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          autoFocus
                          margin="dense"
                          label="Date Of Joining"
                          name="doj"
                          type="date"
                          value={editOfficeInfo.doj}
                          onChange={handleOfficeInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <DateRangeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          label="Designation"
                          name="designation"
                          placeholder="Enter designation "
                          value={editOfficeInfo.designation}
                          onChange={handleOfficeInfoChange}
                          fullWidth
                          className={classes.customTextField}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <WorkIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button onClick={() => handleUpdateUser('office')} color="primary" variant="contained" className={classes.actionButton}>
                      Save Changes
                    </Button>
                    <Button onClick={() => handleEditClose('office')} color="default" variant="outlined" className={classes.actionButton}>
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>
              </TabPanel>

              <TabPanel value={tabIndex} index={1} style={{ marginBottom: "2%" }}>
                <Grid container spacing={4} style={{ marginBottom: '-11px', position: 'relative' }}>

                  {/* Filter Button */}
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                    <Tooltip title="Filter">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={openFilterModal}
                        className={classes.actionButton}
                        style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}
                      >
                        <FilterListIcon style={{ marginRight: activeFilterCount > 0 ? 6 : 0 }} />
                        {activeFilterCount > 0 && `(${activeFilterCount})`}
                      </Button>
                    </Tooltip>
                    <TextField
                      className="user-search-field"
                      label="Search"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      variant="outlined"
                      style={{ width: '300px', backgroundColor: 'transparent' }}
                      InputLabelProps={{
                        shrink: searchQuery !== "",
                        style: {
                          color: '#1b6e95',
                          transform: searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                          transition: 'transform 0.2s ease-in-out',
                        },
                      }}
                      InputProps={{
                        style: {
                          backgroundColor: 'lightgray',
                          borderRadius: '25px',
                          height: "40px",
                          overflow: 'hidden'
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchQuery && (
                              <ClearIcon onClick={handleClearSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit', marginRight: '5px', fontSize: '18px' }} />
                            )}
                            <SearchIcon onClick={handleSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit' }} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {showSuggestions && suggestions.length > 0 && (
                      <Paper style={{ position: 'absolute', zIndex: 1, marginTop: 50, width: "300px" }}>
                        <List>
                          {suggestions.map((suggestion, index) => (
                            <ListItem
                              key={index}
                              button
                              style={{ fontSize: "medium" }}
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion}
                            </ListItem>
                          ))}
                        </List>
                      </Paper>
                    )}
                  </Grid>

                </Grid>

                {/* Filter Modal */}
                <Dialog
                  open={showFilterModal}
                  onClose={() => setShowFilterModal(false)}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    style: {
                      borderRadius: "8px",
                      padding: "0"
                    }
                  }}
                >
                  <DialogTitle style={{
                    backgroundColor: "#1b6e95",
                    color: "white",
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    position: "relative",
                    minHeight: "36px",
                    padding: "8px 0 8px 0",
                    lineHeight: 1.2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    Filter Attendance
                    <CloseIcon
                      style={{
                        position: "absolute",
                        top: 8,
                        right: 10,
                        cursor: "pointer",
                        color: "#fff",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        padding: "2px",
                        width: 28,
                        height: 28
                      }}
                      onClick={() => setShowFilterModal(false)}
                    />
                  </DialogTitle>
                  <DialogContent style={{ padding: "24px" }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <FormControl variant="outlined" fullWidth>
                          <InputLabel id="modal-time-range-label">Time Range</InputLabel>
                          <Select
                            labelId="modal-time-range-label"
                            id="modal-time-range"
                            value={modalTimeRange}
                            onChange={(e) => setModalTimeRange(e.target.value)}
                            label="Time Range"
                          >
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="last7days">Last 7 Days</MenuItem>
                            <MenuItem value="last30days">Last 30 Days</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Start Date"
                          type="date"
                          value={modalStartDate}
                          onChange={(e) => setModalStartDate(e.target.value)}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="End Date"
                          type="date"
                          value={modalEndDate}
                          onChange={(e) => setModalEndDate(e.target.value)}
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <div style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: 12,
                      borderTop: "1px solid #e0e0e0",
                      paddingTop: "16px",
                      marginTop: "24px"
                    }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={applyFilters}
                        style={{
                          minWidth: "100px",
                          backgroundColor: "#1b6e95",
                          textTransform: "none",
                          fontWeight: "600"
                        }}
                      >
                        Apply
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={clearFilters}
                        style={{
                          minWidth: "100px",
                          borderColor: "#1b6e95",
                          color: "#1b6e95",
                          textTransform: "none",
                          fontWeight: "600"
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  </DialogContent>
                </Dialog>

                <Grid container spacing={4} style={{ marginTop: '10px' }}>
                </Grid>
                <Box width="100%">
                  <DataGrid
                    rows={totalDurationTime}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 50]}
                    pagination
                    autoHeight
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '15px',
                      },
                      '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                      },
                      '& .MuiDataGrid-cell': {
                        color: darkMode ? '#ffffff' : 'inherit',
                        fontSize: '14px',
                      }
                    }}
                  />
                </Box>
                <Grid item xs={3} style={{ maxWidth: "21%", marginTop: "-44px", marginBottom: "50px" }} >
                  <ExportButton
                    label="Download Attendance Xlsx"
                    onClick={downloadAttendanceXLSX}
                    className={classes.actionButton}
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={tabIndex} index={2} style={{ marginBottom: "2%" }}>
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      id="datetime-local"
                      className="leave-tab-month-filter"
                      label="Select Month/Year"
                      variant="outlined"
                      type="month"
                      defaultValue={leaveMonthYear.toISOString().slice(0, 7)}
                      onChange={handleMonthChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6} sm={9} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "4px" }}>
                    <TextField
                      className="user-search-field"
                      label="Search"
                      value={searchLeaveQuery}
                      onChange={handleLeaveSearchChange}
                      variant="outlined"
                      style={{ backgroundColor: 'transparent' }}
                      InputLabelProps={{
                        shrink: searchLeaveQuery !== "",
                        style: {
                          color: '#1b6e95',
                          transform: searchLeaveQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                          transition: 'transform 0.2s ease-in-out',
                        },
                      }}
                      InputProps={{
                        style: {
                          backgroundColor: 'lightgray',
                          borderRadius: '25px',
                          height: "40px",
                          overflow: 'hidden'
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchLeaveQuery && (
                              <ClearIcon onClick={handleLeaveClearSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit', marginRight: '5px', fontSize: '18px' }} />
                            )}
                            <SearchIcon style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit' }} onClick={handleLeaveSearch} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {LeaveshowSuggestions && Leavesuggestions.length > 0 && (
                      <Paper className="search-leave" style={{ position: 'absolute', zIndex: 1, marginTop: 5, width: "15%" }}>
                        <List>
                          {Leavesuggestions.map((suggestion, index) => (
                            <ListItem
                              key={index}
                              button
                              style={{ fontSize: "medium" }}
                              onClick={() => handleLeaveSuggestionClick(suggestion)}
                            >
                              {suggestion}
                            </ListItem>
                          ))}
                        </List>
                      </Paper>
                    )}
                  </Grid>
                </Grid>
                <Box width="100%" style={{ marginTop: '20px', marginBottom: "40px" }}>
                  <DataGrid
                    rows={leaveData}
                    columns={leaveColumns}
                    pageSize={pageSize}
                    page={leavePage}
                    onPageChange={(newPage) => setLeavePage(newPage)}
                    getRowId={(row) => row.id} // Adjust based on your data structure
                    autoHeight
                    getRowHeight={() => 'auto'}
                    hideFooter
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '15px',
                      },
                      '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                      },
                      '& .MuiDataGrid-cell': {
                        color: darkMode ? '#ffffff' : 'inherit',
                        fontSize: '14px',
                      }
                    }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <TablePagination
                      component="div"
                      count={leaveData.length}
                      page={leavePage}
                      onPageChange={(event, newPage) => setLeavePage(newPage)}
                      rowsPerPage={pageSize}
                      onRowsPerPageChange={(event) => {
                        setPageSize(parseInt(event.target.value, 10));
                        setLeavePage(0);
                      }}
                      rowsPerPageOptions={[10, 20, 50]}
                      showFirstButton
                      showLastButton
                      sx={{
                        width: 'fit-content',
                        color: darkMode ? 'white' : 'inherit',
                        borderBottom: darkMode ? '1px solid rgba(255, 255, 255, 0.5)' : 'none',
                        '& .MuiTablePagination-selectLabel': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-displayedRows': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-selectIcon': { color: '#1B6E95' },
                        '& .MuiIconButton-root': { color: '#1B6E95' },
                        '& .MuiIconButton-root.Mui-disabled': { color: 'rgba(27, 110, 149, 0.3)' }
                      }}
                    />
                  </div>
                </Box>
              </TabPanel>

              <TabPanel value={tabIndex} index={3} style={{ marginBottom: "2%" }}>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      id="datetime-local"
                      className="salary-slip-month-filter"
                      label="Select Month/Year"
                      variant="outlined"
                      type="month"
                      value={selectedMonthYear}
                      onChange={handleMonthYearChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={6} sm={9} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "4px" }}>
                    <TextField
                      className="user-search-field"
                      label="Search"
                      value={searchSalaryQuery}
                      onChange={handleSalarySearchChange}
                      variant="outlined"
                      style={{ backgroundColor: 'transparent' }}
                      InputLabelProps={{
                        shrink: searchSalaryQuery !== "",
                        style: {
                          color: '#1b6e95',
                          transform: searchSalaryQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                          transition: 'transform 0.2s ease-in-out',
                        },
                      }}
                      InputProps={{
                        style: {
                          backgroundColor: 'lightgray',
                          borderRadius: '25px',
                          height: "40px",
                          overflow: 'hidden'
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchSalaryQuery && (
                              <ClearIcon onClick={handleSalaryClearSearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit', marginRight: '5px', fontSize: '18px' }} />
                            )}
                            <SearchIcon onClick={handleSalarySearch} style={{ cursor: 'pointer', color: darkMode ? '#ffffff' : 'inherit' }} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {SalaryshowSuggestions && Salarysuggestions.length > 0 && (
                      <Paper style={{ position: 'absolute', zIndex: 1, marginTop: 5, width: "15%" }}>
                        <List>
                          {Salarysuggestions.map((suggestion, index) => (
                            <ListItem
                              key={index}
                              button
                              style={{ fontSize: "medium" }}
                              onClick={() => handleSalarySuggestionClick(suggestion)}
                            >
                              {suggestion}
                            </ListItem>
                          ))}
                        </List>
                      </Paper>
                    )}
                  </Grid>
                </Grid>
                <Box width="100%" style={{ marginBottom: "40px" }}>
                  <DataGrid
                    rows={salary}
                    columns={salaryColumns}
                    pageSize={pageSize}
                    page={salaryPage}
                    onPageChange={(newPage) => setSalaryPage(newPage)}
                    rowsPerPageOptions={[10, 20, 50]}
                    autoHeight
                    hideFooter
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '15px',
                      },
                      '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                      },
                      '& .MuiDataGrid-cell': {
                        color: darkMode ? '#ffffff' : 'inherit',
                        fontSize: '14px',
                      }
                    }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <TablePagination
                      component="div"
                      count={salary.length}
                      page={salaryPage}
                      onPageChange={(event, newPage) => setSalaryPage(newPage)}
                      rowsPerPage={pageSize}
                      onRowsPerPageChange={(event) => {
                        setPageSize(parseInt(event.target.value, 10));
                        setSalaryPage(0);
                      }}
                      rowsPerPageOptions={[10, 20, 50]}
                      showFirstButton
                      showLastButton
                      sx={{
                        width: 'fit-content',
                        color: darkMode ? 'white' : 'inherit',
                        borderBottom: darkMode ? '1px solid rgba(255, 255, 255, 0.5)' : 'none',
                        '& .MuiTablePagination-selectLabel': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-displayedRows': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-selectIcon': { color: '#1B6E95' },
                        '& .MuiIconButton-root': { color: '#1B6E95' },
                        '& .MuiIconButton-root.Mui-disabled': { color: 'rgba(27, 110, 149, 0.3)' }
                      }}
                    />
                  </div>
                </Box>
              </TabPanel>

              <TabPanel value={tabIndex} index={4} style={{ marginBottom: "2%" }}>
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                  <Grid item xs={6} sm={3}>
                    <TextField
                      id="leave-balance-month-year"
                      className="leave-balance-month-filter"
                      label="Select Month/Year"
                      variant="outlined"
                      type="month"
                      value={leaveBalanceMonthYear}
                      onChange={handleLeaveBalanceMonthYearChange}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ min: "2000-01", max: new Date().toISOString().slice(0, 7) }}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Box width="100%" style={{ marginTop: '20px', marginBottom: "40px" }}>
                  <DataGrid
                    rows={filteredLeaveBalanceData}
                    columns={leaveBalanceColumns}
                    pageSize={pageSize}
                    page={leaveBalancePage}
                    onPageChange={(newPage) => setLeaveBalancePage(newPage)}
                    loading={leaveBalanceLoading}
                    getRowId={(row) => row.id}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    hideFooter
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? "zebra-table-row" : ""}
                    sx={{
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '15px',
                      },
                      '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#1b6e95',
                        color: 'white',
                        fontWeight: 'bold',
                      },
                      '& .MuiDataGrid-cell': {
                        color: darkMode ? '#ffffff' : 'inherit',
                        fontSize: '14px',
                      }
                    }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <TablePagination
                      component="div"
                      count={filteredLeaveBalanceData.length}
                      page={leaveBalancePage}
                      onPageChange={(event, newPage) => setLeaveBalancePage(newPage)}
                      rowsPerPage={pageSize}
                      onRowsPerPageChange={(event) => {
                        setPageSize(parseInt(event.target.value, 10));
                        setLeaveBalancePage(0);
                      }}
                      rowsPerPageOptions={[10, 20, 50]}
                      showFirstButton
                      showLastButton
                      sx={{
                        width: 'fit-content',
                        color: darkMode ? 'white' : 'inherit',
                        borderBottom: darkMode ? '1px solid rgba(255, 255, 255, 0.5)' : 'none',
                        '& .MuiTablePagination-selectLabel': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-displayedRows': { color: darkMode ? 'white' : 'inherit' },
                        '& .MuiTablePagination-selectIcon': { color: '#1B6E95' },
                        '& .MuiIconButton-root': { color: '#1B6E95' },
                        '& .MuiIconButton-root.Mui-disabled': { color: 'rgba(27, 110, 149, 0.3)' }
                      }}
                    />
                  </div>
                </Box>
              </TabPanel>
              {
                Pdf && (
                  <Dialog
                    open={Pdf}
                    onClick={() => setPdf(false)}
                    style={{ marginTop: "35px" }}
                  >
                    <DialogTitle>Salary Slip</DialogTitle>
                    <DialogContent>
                      {slip && (
                        <iframe title="Salary Slip" src={slip} width="100%" height="500px" />
                      )}
                    </DialogContent>
                  </Dialog>
                )
              }
            </div >
          </div >
        }
      />
      < Footer {...props} />
    </div >
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default UserDetails;
